module.exports = __webpack_public_path__ + "static/media/marketing.8508d589.svg";